import { defineComponent as _defineComponent } from 'vue';
import { provide } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'VList',
  props: {
    dense: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    provide('isInList', true);
    return {
      __sfc: true
    };
  }
});